var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.selectItems,"value-field":_vm.valueField,"text-field":_vm.textField,"readonly":_vm.readonly},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }